import URL from '@/http/gpao/of';
export default {
  namespaced: true,
  state: {
    currentOf: null,
    item_lists: [],
    statutMatieres: [],
    selectedProduit: null,
    checklists: [],
    posteCharges: [],
    priorites: [],
  },

  getters: {
    currentOf: (state) => state.currentOf,
    item_lists: (state) => state.item_lists,
    statutMatieres: (state) => state.statutMatieres,
    selectedProduit: (state) => state.selectedProduit,
    checklists: (state) => state.checklists,
    posteCharges: (state) => state.posteCharges,
    priorites: (state) => state.priorites,
  },

  mutations: {
    SET_CURRENT_OF(state, value) {
      state.currentOf = value;
    },
    SET_ITEM_LISTS(state, value) {
      state.item_lists = value;
    },
    SET_STATUT_MATIERES(state, value) {
      state.statutMatieres = value;
    },
    SET_SELECTED_PRODUIT(state, value) {
      state.selectedProduit = value;
    },
    SET_CHECKLISTS(state, value) {
      state.checklists = value;
    },
    SET_POSTE_CHARGES(state, value) {
      state.posteCharges = value;
    },
    SET_PRIORITES(state, value) {
      state.priorites = value;
    },
  },

  actions: {
    setCurrentOf({ commit }, payload) {
      commit('SET_CURRENT_OF', payload);
    },
    setItemLists({ commit }, payload) {
      commit('SET_ITEM_LISTS', payload);
    },
    setStatutMatieres({ commit }, payload) {
      commit('SET_STATUT_MATIERES', payload);
    },
    setSelectedProduit({ commit }, payload) {
      commit('SET_SELECTED_PRODUIT', payload);
    },
    setChecklists({ commit }, payload) {
      commit('SET_CHECKLISTS', payload);
    },
    setPosteCharges({ commit }, payload) {
      commit('SET_POSTE_CHARGES', payload);
    },
    setPriorites({ commit }, payload) {
      commit('SET_PRIORITES', payload);
    },

    getOf({ commit }, payload) {
      commit('SET_CURRENT_OF', null);

      if (payload.edit) {
        return window.axios
          .get(URL.OF + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_OF', resp.data.of);
          })
          .catch(() => {
            commit('SET_CURRENT_OF', null);
          });
      } else {
        return window.axios
          .get(URL.OF + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_OF', resp.data.of);
          })
          .catch(() => {
            commit('SET_CURRENT_OF', null);
          });
      }
    },
  },
};
